import { InfluencerRegisterEnum } from 'src/Types/users'

export const validateRegisterStatus = (
  userStatus: string,
): InfluencerRegisterEnum => {
  if (
    Object.values(InfluencerRegisterEnum).includes(
      userStatus as InfluencerRegisterEnum,
    )
  ) {
    return userStatus as InfluencerRegisterEnum
  }

  return InfluencerRegisterEnum.JOIN
}
